import Layout from '@/layout'

// 行銷模組：GIMMATEK 只保留分群推播（訊息群發），其餘行銷頁面（標籤管理、事件行銷、追蹤連結…）不提供
// 票券推播（PushCoupon）依賴已移除的票券模組，不註冊
export const marketingRoutes = [
  {
    path: '/marketing',
    component: Layout,
    name: 'Marketing',
    alwaysShow: true,
    isGroup: true,
    meta: {
      title: '行銷模組',
    },
    children: [
      {
        path: 'settings',
        component: () => import('@/components/RouterViewWrapper.vue'),
        name: 'MarketingSetting',
        meta: {
          title: '分群推播管理',
        },
        children: [
          {
            path: 'push-message-setting',
            component: () => import('@/views/Marketing/PushMessageManage/PushMessageSetting'),
            name: 'PushMessageSetting',
            meta: {
              title: '分群推播列表',
              action: 'admin.groupPushMessage.page',
              bobPageAction: 'PAGE_VIEW_DASH_SHOP_MARKETING_PUSHMSG_LIST',
            },
          },
          {
            path: 'push-message',
            component: () => import('@/views/Marketing/PushMessage/PushMessage.vue'),
            name: 'PushMessage',
            hidden: true,
            meta: {
              title: '分群推播',
              action: 'admin.groupPushMessage.page',
              bobPageAction: 'PAGE_VIEW_DASH_SHOP_MARKETING_PUSHMSG_CREATE',
            },
          },
        ],
      },
    ],
  },
]
